export default __webpack_public_path__ + "static/NikkiTaylor-9bed025fcf85333aff1ba7ca37f4ccd1.jpg";